import type Konva from "konva";

export function attachCanvasRenderQueue(stage: Konva.Stage, render: () => void) {
  let dragging = false;
  let pending = false;
  let frame = 0;
  let disposed = false;

  const request = () => {
    if (disposed) return;
    pending = true;
    if (dragging || frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (disposed || dragging) return;
      pending = false;
      render();
    });
  };

  stage.on("dragstart.previewRender", () => {
    dragging = true;
  });
  stage.on("dragend.previewRender", () => {
    dragging = false;
    if (pending) request();
  });

  return {
    request,
    dispose: () => {
      disposed = true;
      cancelAnimationFrame(frame);
      stage.off(".previewRender");
    },
  };
}
